import classNames from 'classnames';

export interface ISkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
	height: number;
	width: number | string;
	animate?: boolean;
}

const Skeleton = ({ height, width, animate = true, className }: ISkeletonProps) => (
	<div
		className={classNames('rounded-lg bg-slate-200', { 'animate-pulse': animate }, className)}
		style={{ width, height }}
	/>
);

export default Skeleton;
